import { UnionCountry } from '@/constants/enum';
import { unionCountries } from '@/constants/options';
import { END_DATE_MARKER, PREP_END_DATE_MARKER, PREP_START_DATE_MARKER, START_DATE_MARKER } from '@/constants/string';

export const capitalizeFirstLetter = (string: string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export function uniq(a: Array<any>) {
  return Array.from(new Set(a.map((item) => stringify(item)))).map((item) => JSON.parse(item));
}

export function uniqByKey(a: Array<any>, key?: string) {
  try {
    if (!key) return Array.from(new Set(a.map((item) => stringify(item)))).map((item) => JSON.parse(item));
    return Array.from(new Set(a.map((item) => stringify(item[key])))).map((item) => a.find((i) => i[key] === JSON.parse(item)));
  } catch (error) {
    console.log(error);
    return a;
  }
}

export const stringify = (input: any) => {
  return JSON.stringify(input);
};

export const checkCountryCodesEquals = (str1: string, str2: string) => {
  // Chuyển chuỗi thành mảng các phần tử, sử dụng trim() để loại bỏ khoảng trắng
  const arr1 = str1.split(',').map((item) => item.trim());
  const arr2 = str2.split(',').map((item) => item.trim());

  // Kiểm tra tất cả các phần tử của mảng arr1 có trong arr2 và ngược lại
  const allInArr2 = arr1.every((item) => arr2.includes(item));
  const allInArr1 = arr2.every((item) => arr1.includes(item));

  return allInArr1 && allInArr2;
};

export const checkCodesExists = (str1: string, str2: string) => {
  // Chuyển chuỗi thành mảng các phần tử, sử dụng trim() để loại bỏ khoảng trắng
  const arr1 = str1.split(',').map((item) => item.trim());
  const arr2 = str2.split(',').map((item) => item.trim());

  const someInArr1 = arr2.some((item) => arr1.includes(item));

  return someInArr1;
};

export const generateShortName = (name: string, separator?: string) => {
  const arrName = name.split(separator ?? ',');
  return arrName.length > 1 ? arrName[0] + ' + ' + (arrName.length - 1) + ' more' : arrName[0];
};

export const splitStringByIndex = (str: string, index: number): string[] => {
  const firstPart = str.substring(0, index);
  const secondPart = str.substring(index);
  return [firstPart, secondPart];
};

export const removeHtmlTag = (input: string): string => input.replace(/&nbsp;/g, ' ').replace(/<[^>]+>/g, '');

export const generateDateDisplay = (estimatedText: string) => {
  const prepMinIndex = estimatedText.indexOf(PREP_START_DATE_MARKER);
  const prepMaxIndex = estimatedText.indexOf(PREP_END_DATE_MARKER);
  const deliveryMinIndex = estimatedText.indexOf(START_DATE_MARKER);
  const deliveryMaxIndex = estimatedText.indexOf(END_DATE_MARKER);
  const indexes = [prepMinIndex, prepMaxIndex, deliveryMinIndex, deliveryMaxIndex]?.filter((index) => index > -1);
  let splitIndex = 0;
  if (indexes.length) splitIndex = Math.min(...indexes);
  return removeHtmlTag(splitStringByIndex(estimatedText, splitIndex)[1]);
};

export const renderListCoutryInRegion = (region: keyof typeof unionCountries) => {
  return unionCountries[region as keyof typeof unionCountries]?.split(',').join(',');
};

export const getRegionNameCountryIn = (region: keyof typeof unionCountries) => {
  let regionName = '';
  Object.keys(unionCountries).forEach((key) => {
    if (key !== 'AllCountriesInAllRegion' && unionCountries[key as keyof typeof unionCountries].includes(region)) {
      //@ts-ignore: next-line
      regionName = UnionCountry[key];
    }
  });
  return regionName;
};

export const replaceRegionByCountry = (text: string) => {
  const newText = text
    .replaceAll(/NorthAmerica/g, unionCountries.NorthAmerica)
    .replaceAll(/SouthAmerica/g, unionCountries.SouthAmerica)
    .replaceAll(/EU/g, unionCountries.EU)
    .replaceAll(/SEA/g, unionCountries.SEA)
    .replaceAll(/EastAsia/g, unionCountries.EastAsia)
    .replaceAll(/SouthAsia/g, unionCountries.SouthAsia)
    .replaceAll(/WestAsia/g, unionCountries.WestAsia)
    .replaceAll(/North America/g, unionCountries.NorthAmerica)
    .replaceAll(/South America/g, unionCountries.SouthAmerica)
    .replaceAll(/European Union/g, unionCountries.EU)
    .replaceAll(/Southeast Asia/g, unionCountries.SEA)
    .replaceAll(/East Asia/g, unionCountries.EastAsia)
    .replaceAll(/South Asia/g, unionCountries.SouthAsia)
    .replaceAll(/West Asia/g, unionCountries.WestAsia);
  return newText;
};

export function normalizeSpaces(input: string): string {
  return input.trim().replace(/\s+/g, ' ');
}

export const convertVietnameseToEnglish = (text: string): string => {
  if (!text) return '';

  return (
    text
      .trim()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[đĐ]/g, 'd')
      // Additional common Vietnamese characters (case-insensitive)
      .replace(/[àáạảãâầấậẩẫăằắặẳẵÀÁẠẢÃÂẦẤẬẨẪĂẰẮẶẲẴ]/gi, 'a')
      .replace(/[èéẹẻẽêềếệểễÈÉẸẺẼÊỀẾỆỂỄ]/gi, 'e')
      .replace(/[ìíịỉĩÌÍỊỈĨ]/gi, 'i')
      .replace(/[òóọỏõôồốộổỗơờớợởỡÒÓỌỎÕÔỒỐỘỔỖƠỜỚỢỞỠ]/gi, 'o')
      .replace(/[ùúụủũưừứựửữÙÚỤỦŨƯỪỨỰỬỮ]/gi, 'u')
      .replace(/[ỳýỵỷỹỲÝỴỶỸ]/gi, 'y')
  );
};
